import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "./AdminLogin.css";

const ADMIN_USERNAME = "Alumini2026";
const ADMIN_PASSWORD = "Alu26@";

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    try {
      const savedAdmin = JSON.parse(localStorage.getItem("adminAuth"));
      if (savedAdmin?.isLoggedIn) {
        navigate("/admin", { replace: true });
      }
    } catch (err) {}
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (error) setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    const username = formData.username.trim();
    const password = formData.password;

    setTimeout(() => {
      if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
        const adminSession = {
          isLoggedIn: true,
          role: "admin",
          username: ADMIN_USERNAME,
          loginAt: new Date().toISOString()
        };

        localStorage.setItem("adminAuth", JSON.stringify(adminSession));

        const redirectPath = location.state?.from?.pathname || "/admin";
        navigate(redirectPath, { replace: true });
      } else {
        setError("Invalid admin username or password");
      }

      setIsLoading(false);
    }, 600);
  };

  const handleForgotPassword = () => {
    const phone = "917092471686";
    const message = "help me, i lost my password";
    const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-header">
        
          <h1>Admin Login</h1>
          <p>Only authorized admin can access the admin dashboard pages.</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="admin-input-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Enter admin username"
              autoComplete="username"
            />
          </div>

          <div className="admin-input-group">
            <label htmlFor="password">Password</label>
            <div className="admin-password-wrap">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter admin password"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="admin-show-btn"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {error && <div className="admin-error-box">{error}</div>}

          <button type="submit" className="admin-login-btn" disabled={isLoading}>
            {isLoading ? "Signing In..." : "Login to Admin"}
          </button>

          <button
            type="button"
            className="admin-forgot-btn"
            onClick={handleForgotPassword}
          >
            Forgot Password?
          </button>
        </form>

        <div className="admin-login-footer">
          

          <Link to="/" className="admin-back-link">
            ← Back to Website
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;